import { STUDIO } from "../data";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#0A0A0A] text-[#FAFAFA] px-6 sm:px-10 pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1600px]">
        <div className="pt-4 flex flex-col sm:flex-row sm:items-center justify-between gap-6 font-body text-sm text-neutral-400">
          <img
            src={STUDIO.logo}
            alt="SO studio"
            className="h-6 w-auto object-contain invert"
          />
          <span>{STUDIO.address}</span>
          <a
            href={STUDIO.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="nav-link text-[#FAFAFA]"
          >
            Instagram {STUDIO.instagramHandle}
          </a>
          <span>© {new Date().getFullYear()} SO studio</span>
        </div>
      </div>
    </footer>
  );
};
